import React, { Component } from "react";
import EnquiryLinksCreationModal from "./enquiryLinksCreationModal";
import { Row, Col, Card, Button, Container, Form, Table, InputGroup, Spinner, Modal } from "react-bootstrap";
import FormReportModal from "./FormreportModal";
import * as Cookies from "es-cookie";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import './_admissionForm.scss';
import * as compose from "lodash.flowright";
 
const DELETE_URL_LINK = gql`
   mutation($id:Int){
    deleteUrlLink(id:$id)
   }
 `;


class Enquiry_Links extends Component {
    constructor(props) {
        super(props);
        this.state = {
            branch_id: "",
            branchError: "",
            EnquiryLinksCreationModal: false,
            existingAdmissionFormFields: [],
            copySuccess: {},
            FormReportModal: false,
            noDateError: "",
            loading: 0,
            admissionFormLinkData: [],
            deleteId: "",
         }
    }

    handleCopyClick = (formUrl) => {
        navigator.clipboard.writeText(formUrl).then(() => {
            this.setState({ copySuccess: { [formUrl]: 'Copied' } });
        });
        setTimeout(() => {
            this.setState({ copySuccess: { [formUrl]: null } });
        }, 1500);
    };

    handleBranchChange = (e) => {
        let name = e.target.name
        let value = e.target.value
        if (name == "branch") {
            this.setState({
                branch_id: value,
                branchError: "",
                loading: 0,
                admissionFormLinkData: [],
                noDateError: "",
            })
        }
    }

    handleBranchSubmit = async (e) => {
        e.preventDefault();
        if (this.state.branch_id == "") {
            this.setState({ branchError: "Please select Branch" })
            return ""
        }

        this.setState({ loader: 1 })

        const result = await this.props.client.query({
            query: gql`
            query($institute_id: Int!,$branch_id: Int!){
                getAdmissionFormLinks(institute_id: $institute_id,branch_id: $branch_id){
                  form_url
                  form_name
                  existing_form_field_id
                  form_field_ids
                  lead_count
                  source_details{
                    source_name
                    source_count
                  }
                }
            }    
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(this.state.branch_id),
            },
            fetchPolicy: 'network-only'
        })
        if (result.data.getAdmissionFormLinks.length > 0) {
            let data = result.data.getAdmissionFormLinks
            this.setState({
                admissionFormLinkData: data,
                loader: 0
            })
        } else {
            this.setState({ loader: 0, noDateError: "No Data Available" })
        }
    }
 
    handleDelete = async (id) => {
        if (window.confirm("Do you want to delete this URL link ?")) {
         await this.props.deleteUrlLink({
            variables:{
                id:id,
            },
            update: (store, { data }) => {
                console.log("data", data);
                if (data.deleteUrlLink) {
                    this.setState({
                        loader: 1,
                        currentStep: 5,
                        submitted: "Deleted Successfully...",
                        spinnerStatus: ""
                    });
                    window.location.reload(false);
                }
            }
        })
    }
    }

    render() {
         console.log("props", this.state);

        return (
            <>
                <Container>
                    <Row className="mt-2">
                        <Col xl={12} lg={12} md={12} sm={12}>
                            <div className="breadcrumb_section border-bottom border-theme pb-1 my-4 d-flex align-items-center justify-content-between">
                                <h6 className="title text-uppercase mb-0">Enquiry Form Links</h6>
                                <div className='d-flex justify-content-end mr-1'>
                                    <div>
                                        <button className="linkCreation_btn text-uppercase" onClick={() => { this.setState({ EnquiryLinksCreationModal: true, existingAdmissionFormFields: [] }) }}>Link Creation</button>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <Row className="mt-2">
                        <Col sm={12}>
                            <Form>
                                <Form.Row>
                                    <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectBranchName">
                                        <Form.Label className="text-uppercase font-weight-bold">Select Branch</Form.Label>
                                        <Form.Control as="select" name="branch" onChange={this.handleBranchChange} value={this.state.branchSearch}>
                                            <option value="">--Select Branch--</option>
                                            {this.props.globals.globalBranches.map(branchData => (
                                                <option value={branchData.id}>{branchData.branch_name}</option>
                                            ))}
                                        </Form.Control>
                                        <Form.Text className="form-text text-danger">
                                            {this.state.branchError}
                                        </Form.Text>
                                    </Form.Group>
                                    <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectBranch">
                                        <button className="w-75 enquiry_link_btn text-uppercase" onClick={this.handleBranchSubmit}>
                                            Submit</button>
                                    </Form.Group>
                                </Form.Row>
                            </Form>
                        </Col>
                    </Row>


                    {
                        this.state.admissionFormLinkData.length > 0 ? (
                            <Row>
                                <Col xl={12} lg={12} md={12} sm={12}>

                                    <Table className="table table-bordered  border-dark" style={{ cursor: "pointer" }}>
                                        <thead className="text-center" style={{ backgroundColor: "rgb(27,35,61)", color: "#fff" }}>
                                            <tr>
                                                <th scope="col">Sno</th>
                                                <th scope="col">Form Name</th>
                                                <th scope="col">Form Url</th>
                                                <th scope="col">Copy</th>
                                                <th scope="col">Edit</th>
                                                <th scope="col">Report</th>
                                                <th scope="col">Delete</th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-center">
                                            {
                                                this.state.admissionFormLinkData.map((item, index) => {
                                                    return (
                                                        <tr>
                                                            <td>{index + 1}</td>
                                                            <td>{item.form_name}</td>
                                                            <td>
                                                                <p style={{ fontWeight: "normal" }}>
                                                                    <a href={item.form_url} target="_blank" rel="noopener noreferrer">
                                                                        {item.form_url}
                                                                    </a>
                                                                </p>
                                                            </td>
                                                            <td>
                                                                {this.state.copySuccess[item.form_url] && <p className='text-success' style={{ fontSize: "10px" }}>Copied</p>}
                                                                <div className="actions-buttons d-flex justify-content-center align-items-top " onClick={() => this.handleCopyClick(item.form_url)}>
                                                                    <Button variant="link" name="view" className="text-theme">
                                                                        <i className="fas  fa-copy text-dark " />
                                                                    </Button>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="actions-buttons d-flex justify-content-center align-items-top" onClick={() => { this.setState({ EnquiryLinksCreationModal: true, existingAdmissionFormFields: [item] }) }}>
                                                                    <Button variant="link" name="view" className="text-theme">
                                                                        <i className="fas fa-edit text-dark" />
                                                                    </Button>
                                                                </div>
                                                            </td>
                                                             <td className="text-center">
                                                                {item.lead_count != null && item.lead_count != "" ? (
                                                                    <div onClick={() => { this.setState({ FormReportModal: true, existingAdmissionFormFields: [item] }) }} className="text-primary" style={{ marginTop: "4px" }}>{item.lead_count}</div>
                                                                ) : (
                                                                    <div style={{ marginTop: "10px" }}>{item.lead_count}</div>
                                                                )}
                                                            </td>

                                                            <td>
                                                                <div className="actions-buttons d-flex justify-content-center align-items-top">
                                                                    <Button variant="link" name="view" className="text-theme"  onClick={() => { this.handleDelete(item.existing_form_field_id) }}>
                                                                        <i className="far fa-trash-alt text-danger"/>
                                                                    </Button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        ) : (
                            <Row>
                                <Col sm={12}>
                                    <div className={this.state.loader == 1 ? "d-flex align-items-center spinner-border text-primary text-center loading-img-center" : ""}></div>
                                </Col>
                                <Col sm={12}>
                                    {
                                        this.state.noDateError != "" ?
                                            (
                                                <h6 className='d-flex justify-content-center align-content-center'>{this.state.noDateError}</h6>
                                            )
                                            :
                                            ("")
                                    }
                                </Col>
                            </Row>
                        )
                    }

                    <EnquiryLinksCreationModal
                        stateData={this.state}
                        show={this.state.EnquiryLinksCreationModal}
                        onHide={() => this.setState({ EnquiryLinksCreationModal: false })}
                        getFormFields={this.props.getFormFields}
                        globals={this.props.globals}
                    />

                    <FormReportModal
                        stateData={this.state}
                        show={this.state.FormReportModal}
                        onHide={() => this.setState({ FormReportModal: false })}
                        getFormFields={this.props.getFormFields}
                    />
                </Container>
            </>
        )
    }
}
export default withRouter(withApollo(compose(
    graphql(DELETE_URL_LINK, {
        name: "deleteUrlLink"
    }),
)(Enquiry_Links)));

